<template>
    <div class="flex-grow overflow-auto">
        <!-- Lista de Agendamentos -->
        <div v-if="showData()">
            <div class="divide-y divide-gray-100">
                <div v-for="schedule in schedules" :key="schedule.id"
                    class="px-4 py-3 hover:bg-gray-50 cursor-pointer transition-colors"
                    :class="searchSelected(schedule.id) ? 'bg-gray-50' : ''"
                    @click="$emit('open:item', schedule)">

                    <div class="flex items-center justify-between">
                        <div class="flex items-center gap-3">
                            <!-- Status indicator -->
                            <div class="w-2 h-2 rounded-full" :class="{
                                'bg-yellow-400': schedule.status === 'pending',
                                'bg-green-500': schedule.status === 'confirmed',
                                'bg-red-400': schedule.status === 'canceled',
                                'bg-blue-500': schedule.status === 'completed',
                            }"></div>

                            <div>
                                <p class="text-sm font-medium text-gray-700">
                                    {{ schedule.title || "Sem título" }}
                                </p>
                                <p class="text-[10px] text-gray-400 line-clamp-1">
                                    {{ schedule.description || "Sem descrição" }}
                                </p>
                            </div>
                        </div>

                        <div class="text-right">
                            <p class="text-[10px] text-gray-400">{{ formatDate(schedule.start) }}</p>
                            <p class="text-[10px] text-gray-500 font-medium">
                                {{ calculateTotalTime(schedule.start, schedule.end) }}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Caso não haja dados -->
        <div v-else class="flex items-center justify-center h-full py-12">
            <div class="text-center text-gray-400">
                <p class="text-sm font-medium">Nenhum agendamento</p>
                <p class="text-xs mt-1">Os agendamentos aparecerão aqui.</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ListSchedules",
    props: {
        schedules: {
            type: Array,
            required: true,
        },
        selected: {
            type: Array,
            required: false,
            default: () => [],
        },
    },
    emits: ["open:item"],
    methods: {
        showData() {
            return this.schedules?.length > 0;
        },
        searchSelected(id) {
            return this.selected.includes(id);
        },
        formatDate(date) {
            if (!date) return "N/A";
            const options = { year: "numeric", month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" };
            return new Date(date).toLocaleDateString("pt-BR", options);
        },
        calculateTotalTime(start, end) {
            if (!start || !end) return "N/A";
            const startTime = new Date(start);
            const endTime = new Date(end);
            const diffInMs = endTime - startTime;

            if (diffInMs < 0) return "Inválido";

            const diffInMinutes = Math.floor(diffInMs / 60000);
            const hours = Math.floor(diffInMinutes / 60);
            const minutes = diffInMinutes % 60;

            return hours > 0 ? `${hours}h ${minutes}m` : `${minutes}m`;
        },
        getStatusClass(status) {
            const classes = {
                pending: "bg-yellow-200 text-yellow-800",
                confirmed: "bg-green-600 text-white",
                canceled: "bg-rose-700 text-white",
                completed: "bg-blue-600 text-white",
            };
            return classes[status] || "bg-gray-200 text-gray-800";
        },
        formatStatus(status) {
            const statusMap = {
                pending: "Pendente",
                confirmed: "Confirmado",
                canceled: "Cancelado",
                completed: "Concluído",
            };
            return statusMap[status] || "Desconhecido";
        },
    },
};
</script>
